import SearchBar from 'components/common/dataTable/searchBar'
import PendingErpSyncReconTable from 'components/pendingErpSync/pendingErpSyncReconTable'
import { Helmet } from 'react-helmet'

const PendingErpSyncRecon = () => {
  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Failed Reconciliations</title>
      </Helmet>

      <div
        className={
          'mb-2 flex flex-wrap items-center justify-between  md:mb-0 md:flex-nowrap'
        }
      >
        <h3 className="title">Failed ERP Sync Reconciliations</h3>
        <SearchBar placeholder="Search by Order Number" />
      </div>

      <PendingErpSyncReconTable />
    </>
  )
}

export default PendingErpSyncRecon
